import React from 'react';
import { IAnswerGroup, IAnswerMapping } from '../QuestionnairePrintView.service';

interface IAddressTemplateProps {
  answerGroups: IAnswerGroup[];
}

const ADDRESS = {
  LINE_1: '0',
  LINE_2: '1',
  FLOOR_APT_SUITE: '2',
  CITY: '3',
  STATE_PROVINCE: '4',
  POSTAL_CODE: '5',
  COUNTRY: '6',
} as const;

const AddressTemplate: React.FC<IAddressTemplateProps> = ({ answerGroups }) => {
  const getFieldValue = (answerMapping: Record<string, IAnswerMapping>, fieldKey: string): string => {
    return answerMapping[fieldKey]?.answerForQuestion || '';
  };

  const joinAddressFields = (fields: string[]): string => {
    return fields.filter(Boolean).join(', ');
  };

  const renderAddressLine = (answerMapping: Record<string, IAnswerMapping>, fieldKeys: string[]): React.ReactNode => {
    const values = fieldKeys.map((key) => getFieldValue(answerMapping, key));
    const joinedValues = joinAddressFields(values);

    return joinedValues ? <p>{joinedValues}</p> : null;
  };

  return (
    <div>
      {answerGroups.map((group, index) => {
        const { answerMapping } = group;

        return (
          <div key={index}>
            {renderAddressLine(answerMapping, [ADDRESS.LINE_1, ADDRESS.LINE_2, ADDRESS.FLOOR_APT_SUITE])}
            {renderAddressLine(answerMapping, [ADDRESS.CITY, ADDRESS.STATE_PROVINCE, ADDRESS.POSTAL_CODE])}
            <p>{getFieldValue(answerMapping, ADDRESS.COUNTRY)}</p>
          </div>
        );
      })}
    </div>
  );
};

export default AddressTemplate;
